import React from 'react';
import { BrainCircuitIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-12 px-4 bg-dark" data-id="element-159">
      <div className="max-w-[680px] mx-auto" data-id="element-160">
        <p className="text-[13px] uppercase tracking-[0.1em] text-gold text-center mb-3" data-id="element-161">
          La Revelación
        </p>
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-body" data-id="element-162">
          LA RAZÓN POR LA QUE NADA TE HA FUNCIONADO ANTES
        </h2>

        <div className="space-y-[12px] text-base text-body leading-[1.5] mb-8 text-center" data-id="element-163">
          <p data-id="element-164">
            La industria del desarrollo personal te vendió una mentira: que el
            cambio viene del pensamiento positivo.
          </p>

          <p data-id="element-165">
            <span className="text-white font-medium" data-id="element-166">
              Tu estado mental no lo controla tu lógica. Lo controlan tus ondas
              cerebrales.
            </span>
          </p>

          <p data-id="element-167">
            En modo estrés crónico, tu cerebro opera en ondas Beta altas. No
            puedes aprender, sanar ni crear. Solo sobrevivir.
          </p>

          <p data-id="element-168">
            Gabriel Beltrán pasó años encontrando el protocolo exacto para mover
            el cerebro de Beta a Theta y Delta — donde ocurre{' '}
            <span className="text-white font-medium" data-id="element-169">la sanación real.</span>
          </p>

          <p data-id="element-170">
            No con fuerza de voluntad.{' '}
            <span className="text-gold font-serif italic text-xl" data-id="element-171">
              Con frecuencia.
            </span>
          </p>

          <p className="mt-4" data-id="element-172">A esto lo llamamos:</p>
        </div>

        <div className="bg-dark-200 border-l-[3px] border-gold p-6 md:p-8 rounded-r-md max-w-[680px] mx-auto text-center" data-id="element-173">
          <h3 className="text-xl md:text-2xl font-bold text-gold mb-2 tracking-wide" data-id="element-174">
            ✦ THE RESET PROTOCOL ✦
          </h3>

          <p className="text-lg md:text-xl font-bold text-gold mb-6" data-id="element-175">
            El Protocolo de Recalibración Mental
          </p>

          <p className="text-lg font-serif text-body italic leading-[1.5]" data-id="element-176">
            30 días. Una frecuencia específica cada mañana. Tu sistema nervioso
            aprende a operar desde un lugar diferente.
          </p>
        </div>
      </div>
    </section>;
}